import { render } from "./emoji_grid.vue?vue&type=template&id=3e22b857"
import script from "./emoji_grid.js?vue&type=script&lang=js"
export * from "./emoji_grid.js?vue&type=script&lang=js"

import "./emoji_grid.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/woodpecker/src/akkoma.dev/AkkomaGang/akkoma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__